import { createLazyComponent } from '@muse-web/router'

export const AsyncSiteFooterContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'site-footer' */ './SiteFooterContainer'),
    'SiteFooterContainer',
    { keepServerMarkup: true },
)
